export const dialerFr = {
  title: "Appeler",
  coming_soon: "Composeur bientôt disponible",
  coming_soon_hint:
    "Le composeur sera activé dès que la connexion téléphonique sera prête.",
  start: "Commencer à appeler",
  start_hint: "Filtre facultatif pour cette session",
  filter_trades: "Métiers",
  filter_regions: "Régions",
  filters: {
    all_trades: "Tous les métiers",
    all_regions: "Toutes les régions",
    selected: "%{smart_count} sélectionné |||| %{smart_count} sélectionnés",
    search_trades: "Rechercher un métier",
    search_regions: "Rechercher une région",
    no_match: "Aucun résultat",
    loading: "Chargement…",
    load_error:
      "Impossible de charger la liste. Vous pouvez quand même commencer à appeler.",
    remove: "Retirer %{name}",
    clear: "Tout effacer",
    callable_title: "Compagnies que vous pouvez appeler maintenant",
    empty_hint:
      "Laissez vide pour appeler toutes vos compagnies par ordre de priorité.",
    best_now: "Meilleur créneau maintenant : %{trade}",
  },
  softphone_warning: "Votre softphone n'est pas vérifié.",
  softphone_setup: "Configurer le téléphone",
  session: {
    active: "En session · %{duration}",
    calls: "Appels",
    contacts: "Contacts",
    demos: "Démos",
    auto: "Auto-composer",
    pause: "Pause",
    resume: "Reprendre",
    end: "Terminer la session",
    today: "Aujourd'hui",
  },
  card: {
    local_time: "%{time} heure locale",
    copy: "Copier",
    copied: "Numéro copié.",
    attempts: "Tentatives : %{count}",
    last: "Dernier : %{outcome} (%{date})",
    next_callback: "Prochain rappel : %{date}",
    assigned: "Assigné à %{name}",
    unassigned: "Non assigné",
    open_full: "Ouvrir la fiche complète",
    high_quality: "Haute qualité",
    score: "Score %{score}",
    website: "Site web : %{url}",
  },
  launch: {
    launched: "Appel lancé dans votre softphone…",
    relaunch: "Relancer",
    dial: "Composer (Entrée)",
    countdown: "Composition dans %{seconds} s — Espace pour annuler",
    blocked:
      "Hors des heures permises (CRTC) pour cette compagnie. Prochaine plage : %{date}.",
    blocked_holiday:
      "Hors des heures permises (CRTC, jour férié) pour cette compagnie. Prochaine plage : %{date}.",
  },
  // GAVION granola-calls
  granola: {
    chip: "Granola",
    chip_hint:
      "Granola passe devant le CRM à chaque appel : cliquez dans le CRM pour retrouver les raccourcis clavier.",
    demo_started: "(démo) Note Granola démarrée",
    // GAVION granola phone: by hand, when the browser blocked the automatic note
    open: "Ouvrir Granola",
    // GAVION inbound calls: at result time, when the kit cannot stop the note (AUTO_STOP=0)
    stop_reminder: "Arrête ta note Granola.",
  },
  // GAVION send-fixes: after a call with a conversation, the follow-up email from the CRM (tracked)
  follow_up: {
    text: "Suivi par courriel pour %{name}",
    send: "Envoyer le suivi",
    dismiss: "Masquer",
  },
  states: {
    claiming: "Recherche de la prochaine compagnie…",
    empty: "Aucune compagnie à appeler",
    empty_hint:
      "Aucune compagnie disponible pour le moment. Importez des compagnies ou élargissez le filtre de la session.",
    next_callback: "Prochain rappel : %{date}",
    to_leads: "Voir les compagnies et importer",
    outside: "Hors des heures d'appel (CRTC). Prochaine plage : %{date}.",
    outside_holiday:
      "Hors des heures d'appel (CRTC, jour férié). Prochaine plage : %{date}.",
    paused: "Session en pause",
    offline: "Hors ligne — les résultats seront envoyés à la reconnexion",
    waiting_online: "Résultat enregistré hors ligne. Reprise à la reconnexion.",
    claim_failed: "Impossible d'obtenir la prochaine compagnie.",
    save_failed: "Échec de l'enregistrement.",
    retry: "Réessayer",
    lease_lost_title: "Cette compagnie a été libérée",
    lease_lost_body:
      "Le verrou a expiré ou a été retiré. Vous pouvez enregistrer quand même le résultat de votre appel, ou passer.",
    save_anyway: "Enregistrer quand même",
    skip: "Passer",
    pause_released: "Pause de plus de 10 minutes : la compagnie a été libérée.",
    demo_deal: "Un deal a été créé pour la démo — le supprimer ?",
    delete_deal: "Supprimer le deal",
    keep_deal: "Garder",
    demo_deal_hint: "Le résultat de cet appel n'est plus une démo.",
    announce: "Compagnie suivante : %{name}",
    continue_queue: "Continuer avec la file",
    cooling_title: "Compagnie en pause",
    cooling_body: "Cette compagnie est en pause — appeler quand même ?",
    cooling_confirm: "Appeler quand même",
    cooling_cancel: "Passer cette compagnie",
    assigned_to_other: "Cette compagnie est attribuée à un autre représentant.",
    // GAVION requeue fix: the queue handed back the rep's open call on this lead (no new dial)
    resumed:
      "Tu as déjà appelé cette compagnie à %{time} sans enregistrer de résultat — choisis un résultat ou Passe.",
    // GAVION requeue fix: leaving the dialer (route, end of session) with a dialled call and no outcome
    no_outcome_title: "Aucun résultat pour %{name}. Enregistrer un résultat ?",
    no_outcome_body:
      "L'appel a été composé, mais aucun résultat n'est enregistré. Sans résultat, il ira dans « À compléter ».",
    no_outcome_choose: "Choisir un résultat",
    no_outcome_skip: "Passer cette compagnie",
    no_outcome_leave: "Quitter quand même",
  },
  outcomes: {
    no_answer: "Pas de réponse",
    voicemail: "Message laissé",
    talked_callback: "Parlé – rappeler",
    demo_booked: "Démo réservée",
    brochure_sent: "Brochure envoyée",
    not_interested: "Pas intéressé",
    wrong_number: "Mauvais numéro",
    do_not_call: "Ne pas appeler",
    skipped: "Passer",
    unlogged: "Non consigné",
    note: "Note",
    what_next: "Ce qui se passe ensuite",
    what_next_none: "Aucune règle active",
  },
  form: {
    note: "Note",
    note_hint: "N pour écrire, Ctrl+Entrée pour enregistrer",
    add_note: "Ajouter une note", // GAVION small fixes: on a phone the note is collapsed
    callback_at: "Date et heure du rappel",
    // GAVION missed-call: no weekend callbacks
    callback_weekdays:
      "Du lundi au vendredi seulement (ni le 25 décembre ni le 1er janvier).",
    chips: {
      tomorrow: "Demain %{time}",
      monday: "Lundi %{time}",
      next_week: "Dans 1 semaine",
    },
    demo_at: "Date et heure de la démo",
    duration: "Durée",
    minutes: "%{n} min",
    attendee_email: "Courriel du participant",
    // GAVION demo-contact: the attendee becomes a contact of the lead
    attendee_name: "Nom du participant",
    attendee_contact_hint:
      "Ajouté aux contacts de la compagnie avec son courriel.",
    amount: "Montant estimé ($)",
    email: "Courriel pour la brochure",
    reason: "Raison",
    reasons: {
      already_supplier: "Déjà un fournisseur",
      no_budget: "Pas le budget",
      bad_timing: "Pas le bon moment",
      not_decision_maker: "Pas le décideur",
      other: "Autre",
    },
    reason_detail: "Précision",
    dnc_confirm: "Le prospect a demandé de ne plus être appelé",
    email_consent: "A accepté de recevoir nos courriels",
    consent_failed:
      "Le consentement courriel n'a pas pu être enregistré : %{reason}",
    consent_offline: "Consentement non enregistré (hors ligne) — à refaire",
    save: "Enregistrer (Ctrl+Entrée)",
    cancel: "Annuler (Échap)",
  },
  errors: {
    callback_required: "Indiquez la date et l'heure du rappel.",
    callback_in_past: "Le rappel doit être dans le futur.",
    callback_outside_hours:
      "Hors des heures permises. Prochaine plage : %{suggestion}.",
    callback_weekend:
      "Pas de rappel la fin de semaine, ni le 25 décembre ou le 1er janvier. Prochain jour ouvrable : %{suggestion}.",
    use_suggestion: "Utiliser ce créneau",
    demo_datetime_required: "Indiquez la date et l'heure de la démo.",
    demo_duration_invalid: "Durée : 30, 45 ou 60 minutes.",
    email_required: "Un courriel valide est requis.",
    reason_required: "Choisissez une raison.",
    confirmation_required: "Confirmez la demande du prospect.",
    edit_window_closed: "Ce résultat ne peut plus être modifié (24 h).",
    lease_lost: "Le verrou sur cette compagnie a été perdu.",
    suppressed: "Ce numéro est sur la liste Ne pas appeler",
    locked: "En cours par %{name}",
    outside_calling_hours: "Hors des heures permises (CRTC)",
    invalid_phone: "Numéro invalide",
    session_not_active: "Aucune session active.",
    dialer_unavailable: "Le composeur n'est pas disponible.",
    unknown: "Une erreur est survenue.",
    outcome_invalid: "Ce résultat n'est pas valide.",
    call_not_found: "Cet appel est introuvable ou n'est pas le vôtre.",
    lead_required: "Choisissez d'abord la compagnie de cet appel.",
    forbidden: "Action réservée aux administrateurs.",
    not_found: "Élément introuvable.",
    // GAVION off-CRM call
    called_at_required: "Indique quand l'appel a eu lieu.",
    called_at_future: "L'appel ne peut pas être dans le futur.",
    called_at_too_old:
      "Seuls les appels des 7 derniers jours peuvent être inscrits.",
    off_crm_forbidden: "Ton compte ne peut pas faire d'appels.",
  },
  queue: {
    later_today: "Plus tard aujourd'hui (%{count})", // GAVION callbacks today
    title: "File (%{count})",
    todo: "À compléter (%{count})",
    history: "Mes appels", // GAVION my-calls
    empty: "File vide",
  },
  // GAVION my-calls: « Mes appels » (/appeler/historique)
  history: {
    title: "Mes appels",
    day: "Jour",
    today: "Aujourd'hui",
    yesterday: "Hier",
    last_7_days: "7 derniers jours",
    date: "Date",
    result: "Résultat",
    all_results: "Tous les résultats",
    results_selected: "%{smart_count} résultat |||| %{smart_count} résultats",
    clear_results: "Effacer",
    no_result: "Sans résultat",
    rep: "Représentant",
    all_reps: "Tous",
    loading: "Chargement…",
    load_failed: "Impossible de charger l'historique des appels.",
    empty: "Aucun appel pour cette période.",
    seconds: "%{n} s",
    minutes: "%{m} min %{s} s",
    show_more: "Voir plus",
    show_less: "Voir moins",
    show_more_label: "Voir toute la note de l'appel à %{lead}",
    show_less_label: "Réduire la note de l'appel à %{lead}",
    pagination: "Pagination des appels",
    pick_date: "Choisissez une date.",
    direction: "Sens",
    directions: { all: "Tous", outbound: "Sortants", inbound: "Entrants" },
    direction_label: { outbound: "Sortant", inbound: "Entrant" },
    range: "%{from}–%{to} sur %{total}",
    previous: "Précédent",
    next: "Suivant",
    columns: {
      date: "Date",
      direction: "Sens",
      lead: "Compagnie",
      contact: "Contact",
      result: "Résultat",
      duration: "Durée",
      note: "Note",
      callback: "Rappel",
      rep: "Représentant",
    },
  },
  script: {
    title: "Script",
  },
  activity: { title: "Historique", empty: "Aucune activité" },
  hotkeys: {
    title: "Raccourcis clavier",
    outcomes: "1–8 : résultats",
    skip: "S : passer",
    note: "N : note",
    enter: "Entrée : composer ou confirmer",
    save: "Ctrl+Entrée : enregistrer",
    space: "Espace : pause ou annuler le compte à rebours",
    escape: "Échap : fermer le formulaire",
    help: "? : afficher cette aide",
    objections: "O : chercher une objection",
  },
  todo: {
    title: "À compléter",
    empty: "Rien à compléter.",
    complete: "Compléter",
    rep: "Représentant",
    all_reps: "Tous",
    dialog_title: "Compléter l'appel",
    outcome: "Résultat",
    saved: "Résultat enregistré.",
    loading: "Chargement…",
    load_failed: "Impossible de charger les appels à compléter.",
    offline:
      "Vous êtes hors ligne : reconnectez-vous pour enregistrer ce résultat.",
    load_more: "Charger plus",
    seconds: "%{n} s",
    columns: {
      date: "Date",
      company: "Entreprise",
      number: "Numéro",
      duration: "Durée",
      disposition: "Statut VoIP.ms",
      rep: "Représentant",
    },
  },
  lead: {
    call: "Appeler",
    someone: "un autre représentant",
    locked_by: "En cours — %{name}",
    locked_tooltip: "Cette compagnie est en cours d'appel par %{name}",
    dnc_tooltip: "Cette compagnie est sur la liste Ne pas appeler",
    invalid_phone_tooltip: "Le numéro de téléphone est invalide",
  },
  outbox: {
    rejected_title: "Résultats hors ligne refusés",
    rejected_toast:
      "%{smart_count} résultat hors ligne refusé par le serveur |||| %{smart_count} résultats hors ligne refusés par le serveur",
    rejected_item: "%{outcome} (appel n° %{call}) — %{error}",
    rejected_hint: "Ces appels restent à compléter dans « À compléter ».",
    dismiss: "J'ai compris",
  },
  timeline: {
    edit_outcome: "Modifier le résultat",
  },
  session_pill: "Appel en cours",
  // GAVION contact-call
  // GAVION off-CRM call: « Inscrire un appel fait hors CRM » (lead page « ... » menu)
  off_crm: {
    menu: "Inscrire un appel fait hors CRM",
    title: "Appel fait hors CRM",
    intro:
      "Un appel fait de ton cellulaire : son résultat compte comme un appel du composeur (rappel, statut de la compagnie, statistiques).",
    when: "Quand",
    who: "Avec qui",
    main_line: "Ligne principale de la compagnie",
    timeline: "Fait hors CRM",
    done: "Appel inscrit",
  },
  contact_call: {
    banner: "Appel — %{contact} (%{type}) — %{company}",
    banner_untyped: "Appel — %{contact} — %{company}",
    unnamed: "Contact sans nom",
    call: "Appeler",
    call_label: "Appeler %{contact} au %{phone}",
    choose_number_label: "Appeler %{contact} : choisir un numéro",
    calls_title: "Appels",
    no_calls: "Aucun appel à ce contact.",
    timeline_to: "À %{contact}",
    // GAVION demo-contact: a demo booked on the main line, its attendee (not a call to him)
    timeline_attendee: "Participant : %{contact}",
    demo_main_line: "Démo réservée sur la ligne principale de la compagnie",
    link_invalid:
      "Impossible d'appeler ce contact : le lien d'appel est invalide (contact ou numéro manquant). Aucun appel n'a été passé.",
    unavailable:
      "Impossible d'appeler ce contact : sa fiche ou ce numéro n'est plus disponible. Aucun appel n'a été passé.",
    back: "Retour",
  },
  // GAVION inbound calls: « Appel entrant » (#/appel-entrant, opened by MicroSIP)
  inbound: {
    title: "Appel entrant",
    from: "Appel de %{phone}",
    loading: "Recherche de la compagnie…",
    recorded: "Appel entrant enregistré sur %{name}. Note Granola ouverte.",
    reused: "Appel entrant déjà enregistré sur %{name}.",
    open_lead: "Ouvrir la fiche de la compagnie",
    open_granola: "Ouvrir Granola",
    contact: "Contact : %{name}",
    choose_title: "Ce numéro est sur plusieurs compagnies : laquelle appelle ?",
    choose: "Choisir",
    unknown_title: "Numéro inconnu",
    unknown_hint:
      "Aucune compagnie ni aucun contact n'a ce numéro. Associez l'appel à une compagnie existante ou créez-en une : la note Granola s'ouvrira ensuite.",
    associate: "Associer à une compagnie",
    search_placeholder: "Nom, ville, téléphone…",
    no_results: "Aucune compagnie trouvée.",
    create: "Créer une compagnie",
    create_name: "Nom de l'entreprise",
    create_phone: "Téléphone : %{phone}",
    create_submit: "Créer et associer l'appel",
    same_name:
      "Plusieurs entreprises portent ce nom : choisissez-en une ou créez-en une nouvelle.",
    create_anyway: "Créer quand même",
    ended: "Appel terminé (%{duration}).",
    already_logged: "Résultat déjà enregistré : %{outcome}.",
    result: "Résultat de l'appel entrant",
    log_result: "Saisir le résultat",
    saved: "Résultat enregistré.",
    none: "Aucun appel entrant enregistré pour ce numéro dans les 4 dernières heures.",
    my_calls: "Mes appels",
    invalid:
      "Numéro absent, masqué ou non nord-américain (%{raw}) : l'appel n'est pas enregistré.",
    errors: {
      forbidden: "Votre compte ne peut pas enregistrer d'appels.",
      not_found: "Cette compagnie ou ce contact n'existe plus.",
      invalid_phone: "Numéro invalide : l'appel n'est pas enregistré.",
      already_logged:
        "Le résultat de cet appel est déjà enregistré : fermez cet onglet.",
      unknown: "Impossible d'enregistrer l'appel entrant. Réessayez.",
    },
  },
};
